import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Grid } from '@mui/material';
import { useOrderDetails } from 'components/context/order_details';

const TopLevelSummary = ({ orderData, orderNumber = null }) => {
  const { t } = useTranslation();
  const { number } = useOrderDetails();

  const shippingText = () => {
    const { min, max, verb, unit } = orderData.shipping_estimate;
    const estimateRangeKey = min ? 'multiple' : 'single';
    const unitNumeralityKey = max === 1 ? 'one' : 'other';

    return t(`checkout.shippingEstimate.summary.${verb}.${estimateRangeKey}`, {
      min,
      max,
      time_unit: t(
        `shipping.shippingEstimate.timeUnits.${unit}.${unitNumeralityKey}`,
      ),
    });
  };

  const bodyText = () => {
    if (orderData.is_warranty) {
      return t('checkout.complete.bodyAlt');
    }

    if (orderData.bopis_fulfillment_selected) {
      return t('checkout.delivery.pickup.completeSubheading', {
        duration: t('checkout.delivery.pickup.soon'),
      });
    }

    if (orderData.no_ship) {
      return '';
    }

    return shippingText();
  };

  return (
    <Grid item>
      <Box component="h3" sx={{ mb: 1 }}>
        {t('checkout.complete.title', { orderNumber: orderNumber ?? number })}
      </Box>
      <p>{bodyText()}</p>
    </Grid>
  );
};

export default TopLevelSummary;
